<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('all_employees')" icon="briefcase">
            <app-default-button btn-class="btn btn-success mr-2"
                                :title="$fieldTitle('add', 'employee', true)"
                                @click="isEmployeeCreateOpenModalActive = true"
                                v-if="$can('add_employees')"
            />
          <app-default-button btn-class="btn btn-success mr-2"
                              :title="$fieldTitle('export', 'employees', true)"
                              @click="viewConfirmationModal"
                              v-if="$can('export_employees')"
          />
<!--          <div class="btn-group dropdown ml-2">-->
<!--            <a v-if="$can('export_attendance_daily_log')" class="dropdown-item" href="#"-->
<!--               @click="viewConfirmationModal">-->
<!--              <app-icon name="download" class="size-16 mr-1"/>-->
<!--              {{ $t('export_attendance') }}-->
<!--            </a>-->
<!--          </div>-->
          <app-confirmation-modal
              v-if="exportConfirmationModal"
              :title="$t('attendance_export_title')"
              :message="$t('attendance_export_message')"
              modal-id="app-confirmation-modal"
              modal-class="primary"
              icon="download"
              :first-button-name="$t('export')"
              :second-button-name="$t('cancel')"
              @confirmed="exportFilteredAttendance()"
              @cancelled="exportConfirmationModal = false"
              :self-close="false"
          />
<!--            <app-default-button-->
<!--                v-if="$can('invite_employees')"-->
<!--                @click="isModalActive = true"-->
<!--                :title="$fieldTitle('invite', 'employee', true)"/>-->
        </app-page-top-section>

        <app-table
            id="employee-table"
            :options="options"
            :card-view="true"
            @getRows="getSelectedRows"
            @action="triggerActions"
        />

        <app-employee-invite
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
        />

        <employee-create-edit-model
            v-if="isEmployeeCreateOpenModalActive "
            v-model="isEmployeeCreateOpenModalActive"
            :selected-url="''"
        />

        <app-confirmation-modal
            :title="promptTitle"
            :message="promptMessage"
            :modal-class="modalClass"
            :icon="promptIcon"
            v-if="confirmationModalActive"
            modal-id="app-confirmation-modal"
            @confirmed="triggerConfirm"
            @cancelled="cancelled"
            :loading="loading"
            :self-close="false"
        />

        <app-employment-status-modal
            v-if="employmentStatusModalActive"
            v-model="employmentStatusModalActive"
            :id="employeeId"
        />

        <app-employee-termination-reason-modal
            v-if="isTerminationReasonModalActive"
            v-model="isTerminationReasonModalActive"
            :id="employeeId"
        />

        <employee-context-menu
            v-if="isContextMenuOpen"
            :employees="selectedEmployees"
            @close="isContextMenuOpen = false"
        />

        <app-attendance-create-edit-modal
            v-if="attendanceModalActive"
            v-model="attendanceModalActive"
            :employee="employee"
        />

        <app-leave-create-edit-modal
            v-if="leaveModalActive"
            v-model="leaveModalActive"
            :employee="employee"
        />

        <job-history-edit-modal
            v-if="isJobHistoryEditModalActive"
            v-model="isJobHistoryEditModalActive"
            :modalType="modalAction"
            :employee="employee"
            @reload="reloadEmployeeTable"
        />

    </div>
</template>

<script>
import EmployeeMixin from "../../Mixins/EmployeeMixin";
import EmployeeContextMenu from "./Components/EmployeeContextMenu";
import JobHistoryEditModal from "./Components/JobHistory/components/JobHistoryEditModal";
import {axiosGet, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import EmployeeCreateEditModel from "./EmployeeCreateEditModal"
import {formatDateForServer, localTimeZone} from "../../../../common/Helper/Support/DateTimeHelper";
import {objectToQueryString} from "../../../../common/Helper/Support/TextHelper";
import {EXPORT_EMPLOYEE} from "../../../Config/ApiUrl";

export default {
    components: {EmployeeContextMenu, JobHistoryEditModal, EmployeeCreateEditModel},
    mixins: [EmployeeMixin],
  data() {
    return {
      exportConfirmationModal: false,
      noDataFoundModal: false,
    }
  },
    mounted() {
        this.getSalaryRange();
    },
    methods:{
        getSalaryRange() {
            axiosGet(this.apiUrl.SALARY_RANGE).then(({data}) => {
                let salaryFilter = this.options.filters.find(item => item.key === 'salary');
                salaryFilter.maxRange = data.max_salary;
                salaryFilter.minRange = data.min_salary < data.max_salary ? data.min_salary : 0;
            })
        },
        viewConfirmationModal() {
          if (this.tableData < 1) {
            this.noDataFoundModal = true;
          } else {
            this.exportConfirmationModal = true;
          }
        },
      exportFilteredAttendance() {
        let query = _.isEmpty(this.queryObject) ? `date=${formatDateForServer(new Date())}` : objectToQueryString(this.queryObject);
        window.location = urlGenerator(`${this.apiUrl.EXPORT_EMPLOYEE}?${query}&timeZone=${localTimeZone}`);
        $("#app-confirmation-modal").modal('hide');
        $(".modal-backdrop").remove();
        this.exportConfirmationModal = false;
      },
    }
}
</script>
